/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Meja_S3Inputs */

const en_tut_meja_s3 = /** @type {(inputs: Tut_Meja_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick the impact statement and press **Terapkan jenis meja**.`)
};

const id_tut_meja_s3 = /** @type {(inputs: Tut_Meja_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centang pemahaman dampaknya lalu tekan **Terapkan jenis meja**.`)
};

/**
* | output |
* | --- |
* | "Tick the impact statement and press **Terapkan jenis meja**." |
*
* @param {Tut_Meja_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_meja_s3 = /** @type {((inputs?: Tut_Meja_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Meja_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_meja_s3(inputs)
	return en_tut_meja_s3(inputs)
});